import { relationship } from '@shared/constants/settings';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { Label } from '@src/design-system/label';
import { PhoneNumberInput } from '@src/design-system/phone-number-input';
import { SelectField } from '@shared/fields/select-field';
import { Textfield } from '@shared/fields/text-field';
import type { TEmergencyContactInfo } from '@shared/types/member';
import { ErrorMessage, useFormikContext } from 'formik';

const EditEmergencyContactInformation = () => {
  const { values, setFieldValue } = useFormikContext<TEmergencyContactInfo>();
  return (
    <div>
      <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
        <p className='text-gray-600 font-medium text-sm mb-2'>
          Emergency Contact Information
        </p>
        <Textfield
          name='name'
          type='text'
          placeholder='ex: Ahmed'
          label='Name'
          className='mb-3'
        />
        <div className='mb-3'>
          <Label className='mb-3'>Relationship</Label>
          <SelectField
            options={relationship}
            selectName='relationship'
            selectPlaceholder='Relationship'
          />
        </div>
        <Textfield
          name='email'
          type='email'
          placeholder='ex: ticlick@gmail.com'
          label='Email'
          className='mb-3'
        />
        <div className='flex flex-col gap-1 mb-3'>
          <Label className='mb-2'>Phone Number</Label>
          <PhoneNumberInput
            name='phone_number'
            placeholder='ex: +20124356762'
            onChange={(value) => setFieldValue('phone_number', value)}
            value={values.phone_number}
          />
          <ErrorMessage
            name='phone_number'
            component={CustomErrorMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default EditEmergencyContactInformation;
